/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import NProgress from 'nprogress'
import { paramToDate } from '../../util/DateString'
import SessionStore from '../../store/SessionStore'
import ReservationCalendarStore from '../../store/reservation/ReservationCalendarStore'
import MonthlyReservationsStore from '../../store/reservation/MonthlyReservationsStore'
import ReservationStore from '../../store/reservation/ReservationStore'
import TaskCollectionStore from '../../store/task/TaskCollectionStore'
import ReservationAction from '../../action/reservation'
import ReservationCalendarView from '../../view/pages/reservations/ReservationCalendarView'
import AutoActionLogsStore from '../../store/auto_action/AutoActionLogsStore'
import AuditsStore from '../../store/AuditsStore'
import AccommodationInvoicesStore from '../../store/reservation/AccommodationInvoicesStore'
import RoomsStore from '../../store/room/RoomsStore'

class ReservationCalendarContainer extends Component {
  static getStores() {
    return [AutoActionLogsStore, ReservationCalendarStore, ReservationStore, TaskCollectionStore, AuditsStore, MonthlyReservationsStore, AccommodationInvoicesStore, RoomsStore, SessionStore]
  }

  static calculateState(prevState, props) {
    return {
      auto_action_logs: AutoActionLogsStore.getState(),
      session: SessionStore.getState(),
      state: ReservationCalendarStore.getState(),
      reservation: ReservationStore.getState(),
      tasks: TaskCollectionStore.getState(),
      invoices: AccommodationInvoicesStore.getState(),
      audits: AuditsStore.getState(),
      monthly: MonthlyReservationsStore.getState(),
      rooms: RoomsStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    // ReservationDetail
    const id = this.state.match.params.id
    if (id) {
      const tab = _.propertyOf(this.state.match.params)('tab')
      await ReservationAction.getReservation(tab, id)
    }

    const dateParam = this.state.match.params.date

    if (dateParam && paramToDate(dateParam)) {
      const date = paramToDate(dateParam)

      if (this.dateChanged()) {
        await ReservationAction.fetchMonthlyByDate(date)
      }
    } else {
      //dateが指定されていなければデフォルトで当日を挿入してmonthChangeさせる
      const date = new Date()
      await ReservationAction.monthChange(date)
    }
    NProgress.done()
  }

  render() {
    return ReservationCalendarView(this.state)
  }

  dateChanged(date) {
    return date !== this.state.monthly.date
  }
}

export default withRouter(Container.create(ReservationCalendarContainer, { withProps: true }))
